import React from 'react'
import { SettingsSectionV2 } from './SettingsSectionV2'

/*
 * System → API rate limit: QUERY_PER_INTERVAL requests every TIMEOUT_INTERVAL
 * seconds, per account, for searches through the public API (developer and
 * compliance screening). A personal package with its own API limits uses
 * those. The "?" by each field says how it works.
 */
const GROUPS = [
  { key: 'api-limits', title: 'Default API limit', sub: 'For every account whose package has no API limits of its own' },
]

export function ApiLimitsV2() {
  return (
    <SettingsSectionV2
      title="API rate limit"
      intro="How many searches an account may run through the API, and how often. A value saved here replaces the ConfigMap one."
      groups={GROUPS}
      layout="rows"
      saveNote={() => 'Each account gets the new limit from its next interval — one already running keeps the old one.'}
    />
  )
}
